// import React from 'react';
// import { FaQrcode } from 'react-icons/fa';

// const CouponPreview = ({ content, expirationDays, messageType }) => {
//   if (messageType !== 'coupon') {
//     return null;
//   }

//   const expirationDate = new Date();
//   expirationDate.setDate(
//     expirationDate.getDate() + parseInt(expirationDays || 0)
//   );

//   return (
//     <div className='bg-white p-4 rounded-lg shadow-md mt-4 max-w-[300px] mx-auto'>
//       <h2 className='text-lg font-bold mb-2'>Coupon Preview</h2>
//       <p className='text-sm mb-2'>{content}</p>
//       <p className='text-sm mb-2'>
//         <strong>Expires:</strong> {expirationDate.toLocaleDateString()}
//       </p>
//       <div className='flex justify-center items-center bg-gray-100 p-4 rounded'>
//         <FaQrcode size={64} />
//       </div>
//       <p className='text-xs text-center mt-2'>Scan to redeem</p>
//       <p className='text-xs text-center mt-1'>
//         localhost:3000/redeem/(unique coupon code)
//       </p>
//     </div>
//   );
// };

// export default CouponPreview;

import React from 'react';
import { FaQrcode } from 'react-icons/fa';

const CouponPreview = ({ content, expirationDate, messageType }) => {
  if (messageType !== 'coupon') {
    return null;
  }

  return (
    <div className='mt-8 p-4 max-w-sm mx-auto bg-white rounded-xl shadow-md space-y-4'>
      <h2 className='text-xl font-bold text-gray-900'>Coupon Preview</h2>
      <h3 className='text-sm font-bold text-gray-500'>
        Please show this to one of the employees
      </h3>

      <div className='mb-4'>
        <strong>Message Content:</strong>
        <p className='text-sm'>{content}</p>
      </div>

      <div className='mb-4'>
        <strong>Expiration Date:</strong>
        <p className='text-sm'>
          {expirationDate
            ? new Date(expirationDate).toLocaleDateString()
            : 'No expiration date'}
        </p>
      </div>

      <div className='mb-4'>
        <strong>Verify using QR Code:</strong>
        <div className='flex justify-center mt-2'>
          <FaQrcode size={128} />
        </div>
      </div>

      <div className='mb-4'>
        <strong>Redeem Status:</strong>
        <p>Not Redeemed</p>
      </div>

      <button
        className='w-full py-2 px-4 text-white font-bold rounded-lg bg-indigo-600 hover:bg-indigo-700'
        disabled
      >
        Redeem (Employee Only)
      </button>
    </div>
  );
};

export default CouponPreview;
